module.exports = __webpack_public_path__ + "img/9788937832611.536371e9.jpg";